const defaultUserImage =
  'https://apiko-app-static-files.s3.us-east-1.amazonaws.com/production/user-images/default-user-image.png';

export const getAvatarUrl = userAvatar => userAvatar || defaultUserImage;

export const getInviteLink = invitationSecret =>
  `${window.location.origin}/invite-user/${invitationSecret}`;
